<template>
  <ContentSection class="overflow-hidden bg-amber-100">
    <Container
      :class="{
        'py-6 sm:py-8 md:py-10 lg:py-12 xl:py-14':
          pageId !== 'c0a53f6a-b1db-4743-8846-000e71cc87a1',
      }"
    >
      <AnimatedContainer
        class="grid auto-rows-min grid-cols-1 lg:grid-cols-3 lg:grid-rows-2 5xl:grid-cols-4"
      >
        <!-- TITLE -->
        <div class="order-1 mb-16 lg:col-span-1 lg:pr-2">
          <h2 class="max-w-sm text-xl tracking-normal md:text-5xl">
            {{ data.heading }}
          </h2>

          <AppButton
            v-if="data.button_link && data.button_text"
            :to="data.button_link"
            aria-label="Gehe zur Übersicht"
            class="mt-10"
          >
            {{ data.button_text }}
          </AppButton>
        </div>
        <!-- SWIPER -->
        <div
          class="relative order-2 mr-[-80%] flex h-fit sm:mr-[-60%] md:col-span-2 md:mr-[-40%] lg:row-span-2 lg:mr-[-20%] 5xl:col-span-3"
        >
          <Swiper
            v-if="Array.isArray(entries) && entries.length > 0"
            :breakpoints="breakpoints"
            @swiper="onSwiper"
            @reach-beginning="
              $refs.sliderButtons.reachedBeginningOrEnd('beginning')
            "
            @reach-end="$refs.sliderButtons.reachedBeginningOrEnd('end')"
            @from-edge="$refs.sliderButtons.fromEdge()"
          >
            <SwiperSlide v-for="post in entries" :key="post.id">
              <EntryCard
                :data="post"
                :class="`${post.color_theme?.value || 'blue'}-el`"
                class="fade-in md:max-w-[31.25rem]"
              />
            </SwiperSlide>

            <!-- EMPTY END SLIDE -->
            <SwiperSlide />
          </Swiper>
        </div>

        <!-- ARROWS -->
        <div
          v-if="Array.isArray(entries) && entries.length > 0"
          class="order-3 items-center justify-end p-6 pr-14 lg:row-start-2 lg:flex"
        >
          <SliderButtons
            ref="sliderButtons"
            class="lg:translate-y-[calc(-50%-1.75rem)]"
            @prev="swiper.slidePrev()"
            @next="swiper.slideNext()"
          />
        </div>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'
import { store } from '/store.js'

// Import Swiper styles
import 'swiper/css'

const props = defineProps({
  data: { type: Object, required: true },
})

// COMPUTED
const pageId = computed(() => {
  return store.pageId
})

const entries = computed(() => {
  return props.data.entries
})

// SWIPER

let swiper = {}

const onSwiper = (swiperElement) => {
  swiper = swiperElement
}

const breakpoints = ref({
  0: {
    slidesPerView: Math.min(2, props.data.entries?.length + 1 || 1),
    spaceBetween: 32,
  },
  768: {
    // md
    slidesPerView: Math.min(2, props.data.entries?.length + 1 || 1),
    spaceBetween: 40,
  },
  1024: {
    // lg
    slidesPerView: Math.min(2, props.data.entries?.length + 1 || 1),
    spaceBetween: 56,
  },
  1536: {
    // 2xl
    slidesPerView: Math.min(2, props.data.entries?.length + 1 || 1),
    spaceBetween: 56,
  },
  1720: {
    // 2xl
    slidesPerView: Math.min(3, props.data.entries?.length + 1 || 1),
    spaceBetween: 56,
  },
  2240: {
    slidesPerView: Math.min(4, props.data.entries?.length + 1 || 1),
    spaceBetween: 56,
  },
  2920: {
    slidesPerView: Math.min(5, props.data.entries.length + 1),
    spaceBetween: 56,
  },
  3920: {
    slidesPerView: Math.min(6, props.data.entries.length + 1),
    spaceBetween: 56,
  },
})
</script>
